// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getTopEarlyFinishedTasks(projectId: string, startDate: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/earliest_finished_tasks${startDate ? `?start_date=${startDate}` : ''}`);
}
